import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import { classNames } from '../functions/classNames';

const useStyles = (fontSize) => makeStyles((theme) => ({
    title: {
        fontSize: fontSize,
        textDecoration: 'none',
        cursor: 'pointer',
        color: theme.palette.text.primary,
        transition: 'all 0.2s ease-in',
        '&:hover': {
            color: theme.palette.secondary.main,
        }
    },
    text: {
        fontSize: fontSize,
    }
}))


const AComponent = ({ fontSize = 14, title, href, typClass = '' }) => {
    const classes = useStyles(fontSize)();
    return (
        <a href={href} title={title} className={classes.title} target="_blank" rel="noopener noreferrer">
            <Typography className={classNames([typClass, classes.text])} variant='body1' dangerouslySetInnerHTML={{ __html: title }} />
        </a >
    )
}


export default React.memo(AComponent);